import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnswerSection from '../common/AnswerSection';
import './AnswersContainer.scss';
var AnswersContainer = /*#__PURE__*/function (_Component) {
  function AnswersContainer(props) {
    var _this;
    _classCallCheck(this, AnswersContainer);
    _this = _callSuper(this, AnswersContainer, [props]);
    _this.state = {};
    return _this;
  }
  _inherits(AnswersContainer, _Component);
  return _createClass(AnswersContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        categories = _this$props.categories,
        questionableId = _this$props.questionableId,
        questionableType = _this$props.questionableType,
        fullView = _this$props.fullView,
        csrfToken = _this$props.csrfToken,
        editMode = _this$props.editMode,
        questionnaireName = _this$props.questionnaireName,
        updateCompletionPercentage = _this$props.updateCompletionPercentage,
        suggestedTags = _this$props.suggestedTags,
        updateSuggestedTags = _this$props.updateSuggestedTags,
        showSuggestionModal = _this$props.showSuggestionModal,
        sectionsNeedingAttention = _this$props.sectionsNeedingAttention,
        onSectionClick = _this$props.onSectionClick;
      return /*#__PURE__*/React.createElement("div", {
        className: "answer-container"
      }, categories.map(function (category) {
        var needsAttention = sectionsNeedingAttention.some(function (section) {
          return section.question_category_id === category[1];
        });
        return /*#__PURE__*/React.createElement("div", {
          key: category[1],
          id: "question-category-".concat(category[1])
        }, /*#__PURE__*/React.createElement(AnswerSection, {
          questionCategoryId: category[1],
          title: category[0],
          questionableId: questionableId,
          questionableType: questionableType,
          fullView: fullView,
          csrfToken: csrfToken,
          editMode: editMode,
          questionnaireName: questionnaireName,
          updateCompletionPercentage: updateCompletionPercentage,
          suggestedTags: suggestedTags,
          updateSuggestedTags: updateSuggestedTags,
          showSuggestionModal: showSuggestionModal,
          needsAttention: needsAttention,
          onAttentionClick: onSectionClick
        }));
      }));
    }
  }]);
}(Component);
AnswersContainer.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))).isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  fullView: PropTypes.bool,
  csrfToken: PropTypes.string,
  editMode: PropTypes.bool,
  questionnaireName: PropTypes.string.isRequired,
  updateCompletionPercentage: PropTypes.func,
  suggestedTags: PropTypes.shape({}),
  updateSuggestedTags: PropTypes.func,
  showSuggestionModal: PropTypes.string,
  sectionsNeedingAttention: PropTypes.arrayOf(PropTypes.shape({})),
  onSectionClick: PropTypes.func
};
AnswersContainer.defaultProps = {
  fullView: true,
  csrfToken: '',
  editMode: false,
  updateCompletionPercentage: function updateCompletionPercentage() {},
  updateSuggestedTags: function updateSuggestedTags() {},
  suggestedTags: {},
  showSuggestionModal: '',
  sectionsNeedingAttention: [],
  onSectionClick: function onSectionClick() {}
};
export default AnswersContainer;